
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag/[slug]",
      function () {
        return require("private-next-pages/tag/[slug].tsx");
      }
    ]);
  